export default {
  selectKf: "Please select customer service",
  table: {
    name: "Name",
    username: "User",
    avatar: "Avt",
    introduction: "Intro",
    status: "Stat",
    totalConversation: "Tot Cnv",
    finishConversation: "Fin Cnv",
    autoFinishConversation: "Auto Fin",
    avgResponseTime: "Resp Time(min)",
    scoreCnt: "Sc Cnt",
    scoreAvg: "Sc Avg",
    lastLoginAt: "Login",
    lastLogoutAt: "Logout",
    createdAt: "Created",
    editTag: "Tag",
    export: "Export",
    respondedSessions: "Resp Ses",
    isOnline: "Online Status",
  },
  message: {
    userNameLength: "Username must be 5-20 characters",
    resetPasswordConfirmation: "Are you sure to reset '{val}' password?",
  },
  form: {
    userName: "Service",
    roleId: "Role",
    tag: "Tag",
  },
};
